import { DCBaseGamepadButtonEvent } from "./DCBaseGamepadButtonEvent.js";
export class DCGamepadUpEvent extends DCBaseGamepadButtonEvent {
    eventType = "gamepad-botton-up";
    inputType = "gamepad-button";
    constructor() {
        super();
    }
}
